import React from "react";
import { useTranslation } from "react-i18next";
import { Users, Building2, Globe2, FileText } from "lucide-react";
import CountUp from "../CountUp";
import { Reveal } from "../motion";

const STATS = [
  { k: "s1", Icon: Users },
  { k: "s2", Icon: Building2 },
  { k: "s3", Icon: Globe2 },
  { k: "s4", Icon: FileText },
];

export default function StatsBar() {
  const { t } = useTranslation();
  return (
    <div className="relative z-30 max-w-[1400px] mx-auto px-6 lg:px-12 -mt-24 lg:-mt-28" data-testid="home-stats">
      <Reveal className="paper grid grid-cols-2 lg:grid-cols-4 divide-y lg:divide-y-0 divide-line lg:divide-x rtl:divide-x-reverse overflow-hidden">
        {STATS.map(({ k, Icon }, i) => (
          <div key={k} className="flex items-center gap-4 lg:gap-5 p-6 lg:p-8 group" data-testid={`home-stat-${k}`}>
            <span className="icon-tile flex-shrink-0">
              <Icon className="h-5 w-5" />
            </span>
            <div className="min-w-0">
              <div className="stat-num">
                <CountUp to={Number(t(`home.stats.${k}_n`))} suffix={t(`home.stats.${k}_suffix`)} duration={1.6 + i * 0.2} />
              </div>
              <div className="mt-1 text-[13px] font-semibold text-ink leading-tight">{t(`home.stats.${k}_l`)}</div>
              <div className="text-[11px] text-slate leading-tight">{t(`home.stats.${k}_s`)}</div>
            </div>
          </div>
        ))}
      </Reveal>
    </div>
  );
}
